/*
 *  Product image Carousel
 *    Scripts for the product media carousel
 *
 *  Version:
 *    1.0.0 - 2020/11/19
 */
import KeenSlider from 'keen-slider';

import { initCarousel, InitCarouselParams } from '../../objects/carousel';
import { CLASS_INITIALISED, CLASS_HIDDEN } from '../../tools/constants/classes';

// Selectors
const SELECTOR_CONTAINER = '[data-product-image-carousel]';
const SELECTOR_CAROUSEL = '[data-product-image-carousel-slides]';
const SELECTOR_DOTS_CAROUSEL = '[data-carousel-dots]';
const SELECTOR_NAVIGATION = '[data-carousel-navigation]';
const SELECTOR_PREV_ARROW = '[data-carousel-previous]';
const SELECTOR_NEXT_ARROW = '[data-carousel-next]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    // Check if section has already been initialized
    if (container.classList.contains(CLASS_INITIALISED)) return;
    container.classList.add(CLASS_INITIALISED);

    const dotsContainer = container.querySelector<HTMLElement>(
      SELECTOR_DOTS_CAROUSEL
    );
    const navigationContainer =
      container.querySelector<HTMLElement>(SELECTOR_NAVIGATION);
    const carouselElement =
      container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
    const prevArrow = container.querySelector<HTMLElement>(SELECTOR_PREV_ARROW);
    const nextArrow = container.querySelector<HTMLElement>(SELECTOR_NEXT_ARROW);

    if (
      !carouselElement ||
      !dotsContainer ||
      !navigationContainer ||
      !nextArrow ||
      !prevArrow
    )
      return;

    /**
     * Gets the index of the current slide
     * Divides by 4 (number of thumbnails visible at once)
     * Rounds the number down to determine how far to scroll (first 4 indices will not scroll therefore we round down to 0)
     * Multiplies the number by the width of the visible container
     * Scrolls container by that amount
     */
    const scrollThumbnailContainer = (carousel: {
      slider: KeenSlider;
      autoplay: (state?: boolean) => void;
      slides: HTMLElement[];
    }) => {
      if (!carousel) return;
      const numberofSlides = carousel.slider.details().size;
      const SHOWN_THUMBNAILS_COUNT = 6;
      const dotsContainerHeight = dotsContainer.offsetHeight;
      const index = carousel.slider.details().relativeSlide;
      // Index used loosely, refers to groups of four thumbnails
      const thumbnail4SlidesIndex = Math.floor(index / SHOWN_THUMBNAILS_COUNT);
      const scrollAmount = thumbnail4SlidesIndex * dotsContainerHeight;

      dotsContainer.scroll({
        top: scrollAmount,
        behavior: 'smooth',
      });

      // // If no previous slide, hide prev arrow
      // if (index === 0) {
      //   prevArrow.classList.add(CLASS_HIDDEN);
      // } else {
      //   prevArrow.classList.remove(CLASS_HIDDEN);
      // }

      // // If no nxt slide, hide next arrow
      // if (index === numberofSlides - 1) {
      //   nextArrow.classList.add(CLASS_HIDDEN);
      // } else {
      //   nextArrow.classList.remove(CLASS_HIDDEN);
      // }
    };

    const options = {
      slidesPerView: 1,
      loop: true,
    };

    let carouselInitialised = null;

    const params = {
      container: carouselElement,
      options,
      dotsContainer,
      navigationContainer,
      onSlideChangedCallback: () =>
        scrollThumbnailContainer(carouselInitialised),
    };

    // Fixed bug on Windows https://prnt.sc/0e9Qxe2MzVa3
    function setContainerWidth() {
      const containerWidth = container.offsetWidth;
      carouselElement.style.width = `${containerWidth}px`;
    }

    window.addEventListener('resize', setContainerWidth);
    window.addEventListener('load', setContainerWidth);

    carouselInitialised = initCarousel(params);
    if (carouselInitialised)
      window.addEventListener('load', () =>
        carouselInitialised.slider.refresh()
      );
  });
